class MemberPricing {
  constructor() {
    this.customerTags = this.getCustomerTags();
    this.init();
  }

  getCustomerTags() {
    // Get customer tags from a data attribute or meta tag
    const customerTagsElement = document.querySelector('[data-customer-tags]');
    if (customerTagsElement) {
      return customerTagsElement.dataset.customerTags
        .split(',')
        .map((tag) => tag.trim());
    }

    // Fallback: check meta tag
    const metaTag = document.querySelector('meta[name="customer-tags"]');
    if (metaTag) {
      return metaTag.content.split(',').map((tag) => tag.trim());
    }

    return [];
  }

  init() {
    // Intercept all product forms
    this.interceptProductForms();

    // Listen for cart updates to apply member pricing
    document.addEventListener('cart:updated', this.handleCartUpdate.bind(this));

    // Listen for variant changes
    document.addEventListener(
      'variant:change',
      this.handleVariantChange.bind(this)
    );
  }

  interceptProductForms() {
    // Find all product forms on the page
    const productForms = document.querySelectorAll('product-form');

    productForms.forEach((form) => {
      const originalSubmitHandler = form.onSubmitHandler;

      form.onSubmitHandler = (event) => {
        // Check if this is a masterclass product and customer is a member
        if (this.shouldApplyMemberPricing(form)) {
          this.applyMemberPricing(form, event);
        } else {
          // Use original handler
          originalSubmitHandler.call(form, event);
        }
      };
    });
  }

  shouldApplyMemberPricing(form) {
    // Check if customer has POWERHOUSE_Member tag
    const isMember = this.customerTags.includes('POWERHOUSE_Member');

    // Check if product has masterclass tag
    const productElement = form.closest('[data-product-id]');
    if (!productElement) return false;

    const productTags = productElement.dataset.productTags;
    if (!productTags) return false;

    const hasMasterclassTag = productTags
      .split(',')
      .some((tag) => tag.trim() === 'masterclass');

    return isMember && hasMasterclassTag;
  }

  async applyMemberPricing(form, event) {
    event.preventDefault();

    const formData = new FormData(form.form);
    const variantId = formData.get('id');

    // Get the member price from the variant metafield
    const memberPrice = this.getMemberPrice(variantId);

    if (memberPrice) {
      // Add member price as a line item property
      formData.append('properties[_Member Price Applied]', memberPrice);

      // Continue with the original form submission
      this.submitFormWithMemberPricing(form, formData);
    } else {
      // Fallback to original handler if no member price found
      form.onSubmitHandler.call(form, event);
    }
  }

  getMemberPrice(variantId) {
    // First try to get from the variant-selects component
    const variantSelects = document.querySelector('variant-selects');
    if (variantSelects) {
      const selectedVariantScript = variantSelects.querySelector(
        '[data-selected-variant]'
      );
      if (selectedVariantScript) {
        try {
          const variant = JSON.parse(selectedVariantScript.textContent);
          if (
            variant.metafields &&
            variant.metafields['bb-strive-app'] &&
            variant.metafields['bb-strive-app']['member-price']
          ) {
            const memberPrice =
              variant.metafields['bb-strive-app']['member-price'];
            return memberPrice.value || memberPrice;
          }
        } catch (e) {
          console.error('Error parsing variant data:', e);
        }
      }
    }

    // Fallback: try to get from product data
    const productElement = document.querySelector('[data-product-id]');
    if (productElement) {
      const selectedVariant = productElement.dataset.selectedVariant;
      if (selectedVariant) {
        try {
          const variant = JSON.parse(selectedVariant);
          if (
            variant.metafields &&
            variant.metafields['bb-strive-app'] &&
            variant.metafields['bb-strive-app']['member-price']
          ) {
            const memberPrice =
              variant.metafields['bb-strive-app']['member-price'];
            return memberPrice.value || memberPrice;
          }
        } catch (e) {
          console.error('Error parsing variant data:', e);
        }
      }
    }

    return null;
  }

  async submitFormWithMemberPricing(form, formData) {
    const config = {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData,
    };

    try {
      const response = await fetch('/cart/add.js', config);
      const result = await response.json();

      if (result.status) {
        // Handle error
        console.error('Error adding to cart:', result);
        return;
      }

      // Trigger cart update
      document.dispatchEvent(new CustomEvent('cart:updated', {detail: result}));

      // Update cart display if available
      const cart =
        document.querySelector('cart-notification') ||
        document.querySelector('cart-drawer');
      if (cart && cart.renderContents) {
        cart.renderContents(result);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  }

  handleCartUpdate(event) {
    // Handle any post-cart-update logic if needed
    console.log('Cart updated with member pricing');
  }

  handleVariantChange(event) {
    // Handle variant changes - the member pricing will be applied on next add to cart
    console.log(
      'Variant changed, member pricing will be applied on next add to cart'
    );
  }
}

// Initialize member pricing when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new MemberPricing();
});
